import { IconMainMenuStackpacks } from "@suse-o11y/icons";
import React from "react";
import { useSelector } from "react-redux";

import { Permission } from "~/models/dto";

import { selectPlayground } from "../../app/state/config/ConfigSelectors";
import { usePermissions } from "../../common/use-permissions";
import { useNavigateToLink } from "../../components/react/link";
import { STACKPACKS_PATH } from "../../routes/stackPacks/StackPacksRoute";

import { MainMenuItemLayout } from "./MainMenuItemLayout";

export const StackPacksMenu: React.FC = () => {
	const hasGetStpackPacksPermission = usePermissions((permissions) =>
		permissions.hasSystemPermission(Permission.GetStackpacks),
	);
	const playground = useSelector(selectPlayground);
	const link = useNavigateToLink(STACKPACKS_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	if (!(playground || hasGetStpackPacksPermission)) {
		return null;
	}

	return (
		<MainMenuItemLayout
			className="stackPacksMenu"
			data-testid="stackpacks-menu"
			defaultOpen={false}
			disabled={!hasGetStpackPacksPermission}
			icon={<IconMainMenuStackpacks height={18} width={18} />}
			label="StackPacks"
			to={link}
		/>
	);
};
